import React, { useEffect, useState } from 'react';
import { CustomButton } from '../../../../components/Button/Button';
import LogoEditorCard from '../../../../components/LogoEditorCard/LogoEditorCard';
import { useLogoContext } from '../../../../context/LogoContext';
import styles from './LogoChooser.module.scss';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '../../../../context/UserContext';
import CloseButton from '../../../../components/CloseButton/CloseButton';

const LogoChooser = ({ videoLogo, handleLogoChange, saveOnClose = false, miniSidebar, closeFeatures }) => {
  const [initialLogo, setInitialLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const { appConfig } = useUserContext();

  const { disableLogoEditor, currentLogoFromEditor, setCurrentLogoFromEditor } = useLogoContext();

  const { t } = useTranslation();

  const handleChooseLogo = (value = null) => {
    if (value?.id === currentLogoFromEditor?.id) {
      setCurrentLogoFromEditor(null);
    } else {
      setCurrentLogoFromEditor(value);
    }
  };

  const parseLogoPath = url => {
    if (url) {
      const urlArray = url.split('/');
      const logoNameItem = urlArray[urlArray.length - 1];
      return logoNameItem.split('?')[0];
    }
  };

  const handleSaveLogo = async () => {
    try {
      setLoading(true);
      await handleLogoChange(currentLogoFromEditor, true);
    } catch (e) {
      console.log('Error While saving', e);
    }
    disableLogoEditor();
  };

  const handleClose = () => {
    saveOnClose && handleLogoChange(initialLogo);
    disableLogoEditor();
  };

  useEffect(() => {
    if (miniSidebar || closeFeatures) {
      handleClose();
    }
  }, [miniSidebar, closeFeatures]);

  useEffect(() => {
    const logo = appConfig?.company_logos.find(item => parseLogoPath(item.path) === parseLogoPath(videoLogo?.path ?? videoLogo?.url));
    setCurrentLogoFromEditor(logo);
  }, [videoLogo]);

  useEffect(() => {
    if (videoLogo) {
      const logo = appConfig?.company_logos.find(item => parseLogoPath(item.path) === parseLogoPath(videoLogo?.path ?? videoLogo?.url));
      setInitialLogo(logo);
    }

    return () => disableLogoEditor();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.headerContainer}>
          <h2 className={styles.editorHeader}>{t('logo_chooser.header')}</h2>
          <CloseButton onClose={handleClose} />
        </div>
        <ul className={styles.logoContainer}>
          <LogoEditorCard key={'noLogo'} active={!currentLogoFromEditor?.id} onChoose={handleChooseLogo} />

          {appConfig?.company_logos?.map(item => (
            <LogoEditorCard key={item.id} logo={item} active={item.id === currentLogoFromEditor?.id} onChoose={handleChooseLogo} />
          ))}
        </ul>
      </div>
      <div className={styles.bottomContainer}>
        <CustomButton
          variant="primary"
          label={t('logo_chooser.save_logo')}
          loadingText={t('clip_organizer.saving')}
          disabled={initialLogo ? currentLogoFromEditor?.id === initialLogo?.id : !Boolean(currentLogoFromEditor)}
          onClick={handleSaveLogo}
          className={styles.saveBtn}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default LogoChooser;
